export const AUTHORIZATION_HEADER_PREFIX = "Bearer"

export const BROWSER_STORAGE_KEYS = {
  auth: "auth",
}

export enum ServicePrefix {
  nebula = "nebula",
  solis = "solis",
  gravity = "gravity",
  doppler = "doppler",
  mercury = "mercury",
}

export const USER_TYPE = "Application Form Admin"
